import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import "./text.vue?vue&type=style&index=0&id=cb3d0e3a&lang=scss"

const __exports__ = script;

export default __exports__